import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    DELETE_WORK_SPACE: createActionType(FULL_NAMESPACE, "DELETE_WORK_SPACE"),
    DELETE_WORK_SPACE_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_WORK_SPACE_COMPLETED")
};
